<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <Modal
            :text="modalText"
            id="modal_show"
        />

        <div class="container">
            <FormTag>
                    <div class="grid grid-cols-12 gap-3 p-0">

                        <div class="col-span-12 md:col-span-6 position-relative pl-0 mt-5">
                            <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-4">
                                {{ $t('name') }}
                            </div>
                            <InputBox
                                model-name="name"
                                check-to-model="modelNotEmptyState"
                                :model-form="modelForm"
                                :errors="errors"
                                :no-margin-top="true"
                            />
                        </div>

                        <div class="col-span-12 md:col-span-6 position-relative pl-0 mt-10">
                            <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-9 ml-4">
                                {{ $t('category') }}
                            </div>
                            <TreeCheckBox
                                model-name="parent"
                                :model-form="modelForm"
                                :options="this.getProductCategoriesTree"
                                :errors="errors"
                                :multiple="false"
                            />
                        </div>

                        <div class="col-span-12 md:col-start-10 md:col-span-3">
                            <SubmitRow
                                class="mt-4 pb-4 px-3"
                                sm-size="12"
                                md-size="12"
                                v-if="canManageProducts()"
                                :is-disabled="hasErrors"
                                :is-loading="isLoading"
                                :do-action="add"
                                :text="submitButtonName"
                            />
                        </div>
                    </div>



            </FormTag>
        </div>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import validatorMixin from "../../mixin/validatorMixin";
import Row from "../../components/html/Row";
import FormTag from "../../components/html/FormTag";
import InputBox from "../../components/InputBox";
import SubmitRow from "../../components/SubmitRow";
import accessMixin from "@/mixin/accessMixin";
import TreeCheckBox from "@/components/TreeCheckBox";
import Modal from "@/components/html/Modal";

export default {
    name: "ProductsAdd",
    components: {
        TreeCheckBox,
        SubmitRow,
        InputBox,
        FormTag,
        Row,
        Modal,
    },
    mixins: [validatorMixin, accessMixin],
    data() {
        return {
            submitButtonName: 'add',
            modalText: '',
            isLoading: false,
            errors: {
                name: null,
                parent: null,
            },
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'category', url: 'product-categories'},
                {name: 'add'},
            ],
            modelForm: {
                id: null,
                name: '',
                parent: null,
            },
        }
    },
    computed: {
        ...mapGetters(['getWarehouses', 'getProductCategory', 'getProductCategoriesTree']),
    },
    methods: {
        ...mapActions(['fetchProductCategoriesTree', 'fetchProductCategory', 'pushProductCategories', 'setBreadcrumbItems']),
        add() {
            this.isLoading = true

            this.pushProductCategories(this.modelForm)
                .then(() => {
                    this.isLoading = false
                    this.$i18nHelper.toUrl('product-categories')
                })
                .catch((reason) => {
                    this.isLoading = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show')
                })
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.fetchProductCategoriesTree()

        if (this.$route.params.id) {
            this.fetchProductCategory(parseInt(this.$route.params.id))
                .then(() => {
                    this.submitButtonName = 'edit'

                    this.modelForm.id = this.getProductCategory.id
                    this.modelForm.name = this.getProductCategory.name
                    this.modelForm.parent = this.getProductCategory.parent
                })
        }
    },
}
</script>

<style scoped>

</style>